import {Button, FormControl, IconButton, Input, InputGroup, InputRightElement, Text, VStack} from "@chakra-ui/react";
import * as React from "react";
import {useEffect, useState} from "react";
import {changePage, setFieldModel, setIsLeftToRight, setIsSignup} from "../../../store/reducers";
import {useAppDispatch, useAppSelector} from "../../../hooks/use-store";
import {Resolver, useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import {signupProducerSchemaNew} from "../../../data/schema/signup";
import {ProducerModelQueryParamsNew} from "../../../data/model/Producer";
import {ViewIcon, ViewOffIcon} from "@chakra-ui/icons";

export const SignupPageOne = () => {
    const {currentPage, producer} = useAppSelector((state) => state.landing);
    const dispatch = useAppDispatch();

    // const methods = useForm<ProducerModelQueryParams>({
    //     mode: "all",
    //     resolver: yupResolver(signupSchemaOne) as Resolver<ProducerModelQueryParams>
    // });
    //
    const methods = useForm<ProducerModelQueryParamsNew>({
        mode: "all",
        resolver: yupResolver(signupProducerSchemaNew) as Resolver<ProducerModelQueryParamsNew>
    });

    const {email, password} = producer || {};

    const {
        register,
        getValues,
        setValue,
        trigger,
        formState: {
            errors,
            isSubmitting, isValid
        }
    } = methods;

    function onSubmit() {
        const values = getValues()
        dispatch(setFieldModel(values));
        dispatch(changePage((currentPage ?? 0) + 1));
    }

    useEffect(() => {
        if (!!email) {
            setValue("email", email);
            trigger("email").then();
        }

        if (!!password) {
            setValue("password", password);
            trigger("password").then();
        }
    }, [email, password, setValue])

    const [showPassword, setShowPassword] = useState(false);

    return (
        <VStack>
            <FormControl isInvalid={!!errors.email}>
                {/*<Text*/}
                {/*    color={"primary.400"}*/}
                {/*    fontSize={16}*/}
                {/*>Username (*)</Text>*/}
                {/*<Input*/}
                {/*    id={"username"}*/}
                {/*    inputMode={"text"}*/}
                {/*    focusBorderColor={!!errors.username ? "error.700" : "primary.400"}*/}
                {/*    errorBorderColor={"error.700"}*/}
                {/*    colorScheme={"primary"}*/}
                {/*    variant='filled'*/}
                {/*    isInvalid={!!errors.username}*/}
                {/*    _placeholder={{*/}
                {/*        fontSize: 14*/}
                {/*    }}*/}
                {/*    {...register('username')}*/}
                {/*    placeholder='Es. mariorossi1'/>*/}
                {/*<Text fontSize={14} mt={"8px"} textColor={"error.700"}>*/}
                {/*    {errors.username && errors.username.message}*/}
                {/*</Text>*/}

                <Text
                    color={"primary.400"}
                    fontSize={16}
                    mt={"24px"}>Email (*)</Text>
                <Input
                    id={"email"}
                    inputMode="email"
                    errorBorderColor={"error.700"}
                    focusBorderColor={!!errors.email ? "error.700" : "primary.400"}
                    variant='filled'
                    isInvalid={!!errors.email}
                    colorScheme={"primary"}
                    placeholder='mariorossi@mail.it'
                    _placeholder={{
                        fontSize: 14
                    }}
                    {...register('email')}
                />
                <Text fontSize={14} mt={"8px"} textColor={"error.700"}>
                    {errors.email && errors.email.message}
                </Text>

                <Text
                    color={"primary.400"}
                    fontSize={16}
                    mt={"24px"}>Password (*)</Text>
                <InputGroup>
                    <Input
                        id={"password"}
                        inputMode="text"
                        type={showPassword ? 'text' : 'password'}
                        errorBorderColor={"error.700"}
                        focusBorderColor={!!errors.password ? "error.700" : "primary.400"}
                        variant='filled'
                        isInvalid={!!errors.password}
                        colorScheme={"primary"}
                        placeholder='Inserisci la password'
                        _placeholder={{
                            fontSize: 14
                        }}
                        {...register('password')}
                    />
                    <InputRightElement width="4.5rem">
                        <IconButton
                            h="1.75rem"
                            size="sm"
                            onClick={() => {
                                setShowPassword(!showPassword)
                            }}
                            icon={showPassword ? <ViewOffIcon/> : <ViewIcon/>}
                            aria-label={showPassword ? 'Nascondi password' : 'Mostra password'}
                        />
                    </InputRightElement>
                </InputGroup>
                <Text fontSize={14} mt={"8px"} textColor={"error.700"}>
                    {errors.password && errors.password.message}
                </Text>

                <Text
                    color={"primary.400"}
                    alignSelf={"start"}
                    mt={"8px"}
                    fontSize={11}>Deve contenere almeno una lettera maiuscola,{"\n"}un numero e un carattere
                    speciale</Text>

                {currentPage !== 3 &&
                    <Button
                        isDisabled={!isValid}
                        variant={"primary"}
                        mt={"48px"}
                        type={"submit"}
                        onClick={() => {
                            // handleSubmit(onSubmit);
                            // console.log("TEST");
                            // handleSubmit(onSubmit)
                            dispatch(setIsLeftToRight(false));
                            onSubmit();
                        }}
                    >Avanti</Button>}

            </FormControl>

            {currentPage === 0 && <Text
                color={"tertiary.300"}
                onClick={() => {
                    dispatch(setIsSignup(false))
                }}
                cursor={"pointer"}
                alignSelf={"center"}
                textDecoration={"underline"}
                textAlign={"center"}
                mt={"8px"}
                mb={"24px"}
                fontSize={16}>Hai un account? Accedi adesso</Text>}
        </VStack>
    )

    /*return <VStack w={"100%"}>
        <Text
            color={"primary.400"}
            alignSelf={"start"}
            fontSize={16}>Username</Text>

        <Input
            name={"username"}
            inputMode={"text"}
            onBlur={fieldUsername.onBlur}
            onChange={fieldUsername.onChange}
            isInvalid={invalidUsername}
            focusBorderColor={"primary.400"}
            errorBorderColor={"error.700"}
            colorScheme={"primary"}
            variant='filled'
            _placeholder={{
                fontSize: 14
            }}
            placeholder='Es. mariorossi1'/>

        <Text
            color={"primary.400"}
            alignSelf={"start"}
            mt={"24px"}
            fontSize={16}>Email</Text>

        <Input
            name={"email"}
            inputMode="email"
            onBlur={fieldEmail.onBlur}
            onChange={fieldEmail.onChange}
            isInvalid={invalidEmail}
            errorBorderColor={"error.700"}
            focusBorderColor={"primary.400"}
            variant='filled'
            colorScheme={"primary"}
            placeholder='mariorossi@mail.it'
            _placeholder={{
                fontSize: 14
            }}
        />

        <Text
            color={"primary.400"}
            alignSelf={"start"}
            mt={"24px"}
            fontSize={16}>Password</Text>

        <Input
            name={"password"}
            focusBorderColor={"primary.400"}
            variant='filled'
            colorScheme={"primary"}
            placeholder='Inserisci la password'
            _placeholder={{
                fontSize: 14
            }}
        />

        <Text
            color={"primary.400"}
            alignSelf={"start"}
            mt={"8px"}
            fontSize={11}>Deve contenere almeno una lettera maiuscola,{"\n"}un numero e un carattere speciale</Text>

        {currentPage !== 3 && <Button
            variant={"primary"}
            mt={"48px"}
            onClick={() => {
                dispatch(changePage((currentPage ?? 0) + 1));
            }}
        >Avanti</Button>}

        {currentPage === 0 && <Text
            color={"tertiary.300"}
            onClick={() => {
                dispatch(setIsSignup(false))
            }}
            cursor={"pointer"}
            alignSelf={"center"}
            textDecoration={"underline"}
            textAlign={"center"}
            mt={"8px"}
            mb={"24px"}
            fontSize={16}>Hai un account? Accedi adesso</Text>}
    </VStack>*/
}
